/* eslint-disable */

import React, { useEffect, useMemo } from 'react'

import { Box, Button, Container, Divider, Grid, Typography } from '@aura/components'
import { withStyles } from '@aura/components/styles'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import CustomLoader from '../../../../components/custom-loader'
import RegistrationContainer from '../../../../components/new-registration-container'
import FetchUserAppsStatus from '../../../../constants/fetch-user-apps'
import { isFrench } from '../../../../constants/app'
import { loginUrls } from '../../../../appConfig'
import styles from './styles'


const Component = ({
    classes,
    initUserApps,
    data,
    userAppsStatus
}) => {

    const { t: translate, i18n } = useTranslation()

    useEffect(() => {
        initUserApps()
    }, [])

    const isLoading = userAppsStatus === FetchUserAppsStatus.PENDING

    const myApps = data && data.myApps ? data.myApps.filter(app => app.url && loginUrls.some(suffix => app.url.endsWith(suffix))) : null

    const generalLogin = data && data.generalLogin ? data.generalLogin : null

    const [loginTextFirst, loginTextSecond] = translate('registrationFlow.loginText').split('.')
    const mainContent = useMemo(() => {
        return <div className={classes.fieldsContainer}>
            {isLoading ? (
                <CustomLoader
                    label={translate('loading')}
                    style={{ marginBottom: '100px', marginTop: '26%', width: '100%' }}
                />
            ) : <>
                <Container>
                    <Box className={classes.firstPart}>
                        <CheckCircleOutlineIcon className={classes.checkIcon}></CheckCircleOutlineIcon>
                        <Typography className={classes.registrationSuccess}>{translate('registrationFlow.registrationSuccess')}</Typography>
                        <Typography className={classes.loginTextFirst}>{loginTextFirst + '.'}</Typography>
                        <Typography className={classes.loginTextSecond}>{loginTextSecond}</Typography>

                    </Box>
                    <Divider className={classes.headerDivider} />
                </Container>
                <Box className={classes.secondPart}>
                    <Typography className={`${classes.loginTextSecond} ${classes.secondPartText}`}> {translate('registrationFlow.appsText')}</Typography>
                    <Box className={classes.buttonContainer}>
                        <Button
                            className={`${classes.nextButton}`}
                            disabled={!generalLogin}
                            onClick={() => { window.open(generalLogin, '_blank') }}>
                            {translate('login')}
                        </Button>
                    </Box>
                    {myApps && myApps.length > 0
                        ? <>
                            <Typography className={classes.loginTextSecond} variant="body2">{translate('signInBack.newQuickSignIn')}</Typography>
                            <Box className={classes.signIntoApps} mt={2} mb={2} display="flex" flexWrap="wrap" gap="10px">
                                {Object.values(myApps).map(rec => (
                                    <Grid key={rec.appNameEn} item>
                                        <Button
                                            className={classes.appsButton}
                                            disabled={!myApps || !rec.url}
                                            onClick={() => { rec.url && window.open(rec.url, '_blank'); setCookieHandler() }}

                                        >
                                            {isFrench(i18n.language) ? rec.appNameFr : rec.appNameEn}
                                        </Button>
                                    </Grid>
                                ))}
                            </Box>
                        </>
                        : <></>}
                </Box>
            </>
            }
        </div>

    }, [classes, translate, isLoading, myApps, generalLogin, i18n.language])
    return (<RegistrationContainer {...{ mainContent }}>

    </RegistrationContainer>)
}

Component.displayName = 'SignIn'

Component.defaultProps = {
    data: {
        myApps: []
    }
}

Component.propTypes = {
    classes: PropTypes.shape({
        button: PropTypes.object,
        buttonContainer: PropTypes.object,
        fieldsContainer: PropTypes.object,
        signIntoApps: PropTypes.object
    }),
    data: PropTypes.object.isRequired,
    initUserApps: PropTypes.func.isRequired,
    userAppsStatus: PropTypes.string
}

export default withStyles(Component, styles)
